module.exports = new __parcel__URL__("AISuggestions2.4758db65.png").toString();